import { useMemo } from 'react';
import { isUngatedFor } from '../api/gates';
import { TrellisAvatarDisplay } from './TrellisAvatarDisplay';
import { LegacyAvatarDisplay } from './LegacyAvatarDisplay';
import { GATES } from '../Constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const AvatarDisplay = props => {
  const isUngatedForTrellisIcons = useMemo(() => isUngatedFor(GATES.TRELLIS_AVATAR_ICONS_GATE), []);
  if (isUngatedForTrellisIcons) {
    return /*#__PURE__*/_jsx(TrellisAvatarDisplay, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(LegacyAvatarDisplay, Object.assign({}, props));
};